import { CreateOptionItem } from '@/common/components/form-creatable-combobox/types.ts';

export function isCreateOption(option: unknown): option is CreateOptionItem {
  return (
    typeof option === 'object' &&
    option !== null &&
    'inputValue' in option &&
    'key' in option &&
    option.key === '@@CREATE' &&
    'label' in option
  );
}

export function defaultGetOptionLabel(option: unknown): string {
  if (typeof option === 'object' && option !== null && 'label' in option) {
    return `${option.label}`;
  }
  return '-- missing label --';
}
